import { computed } from 'vue';

export default function useSizeByBounds(bounds) {
  const size = computed(() => ({
    x: bounds.value.left,
    y: bounds.value.top,
    width: bounds.value.right - bounds.value.left,
    height: bounds.value.bottom - bounds.value.top,
  }));

  return { size };
}
